module.exports = __webpack_public_path__ + "static/img/swiper_01.3ceb712.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/swiper_01.png
// module id = JNia
// module chunks = 1